<template>
    <div class="protocolBinding">
        <div class="section">
            <div class="search">
                <div class="searchLeft">
                  <span class="search-label">{{ $t('colUnBindRecord.unStatus') }}</span>
                  <el-select
                    v-model="unBindAlarmStatus"
                    :placeholder="$t('header.pleaseSelect')"
                    size="small"
                    clearable
                    @change="getDeviceList(true)"
                    popper-class="select-search-recharge"
                    class="selectClearNew"
                  >
                    <el-option v-for="(value, key) in ubStatusList" :key="key" :value="key" :label="value.label"
                      style="display: flex; align-items: center">
                      <i style="width: 10px; height: 10px; margin-right: 8px" :class="`status-${value.name}`"></i>
                      <span class="select-label">{{ value.label }}</span>
                    </el-option>
                  </el-select>
                </div>
                <div class="searchRight">
                    <!-- 搜索 -->
                    <div class="adminSearch">
                        <el-input class="searchAll" ref="iptFocus" v-model.trim="pn"
                            @keyup.enter.native="getDeviceList(true)" :placeholder="$t('datalogger.search_PN')"
                            clearable>
                        </el-input>
                        <!-- 搜索 -->
                        <span class="search-device" @click="getDeviceList(true)">{{ $t('recharge.Search') }}</span>
                    </div>
                </div>
            </div>
            <el-table
                :data="deviceList"
                border
                stripe
                height="100%"
                :cell-style="{ padding: 0 }"
                :row-key="getRowKey"
                :header-cell-style="{ background: 'rgb(65, 80, 90)', color: '#ffffff' }"
                v-loading="loadingDevice"
                element-loading-spinner="el-icon-loading"
                class="tablemain tableloding"
                :tree-props="{ children: 'details' }"
                >
                <!-- default-expand-all -->
                <!-- 父级行 -->
                <el-table-column min-width="180px;" fixed :show-overflow-tooltip="true" label="PN">
                    <template slot-scope="scope">
                        <span v-if="scope.row.pn" :title="scope.row.pn" :class="{'redirects':scope.row.pn}">{{ scope.row.pn || "--" }}</span>
                        <span v-else>--</span>
                    </template>
                </el-table-column>
                <el-table-column :show-overflow-tooltip="true" :label="$t('colUnBindRecord.unScene')">
                    <template slot-scope="scope">
                        <span v-if="scope.row.unBindSceneName">{{ scope.row.unBindSceneName }}</span>
                        <span v-else>--</span>
                    </template>
                </el-table-column>
                <el-table-column :show-overflow-tooltip="true" :label="$t('colUnBindRecord.oldUser')">
                    <template slot-scope="scope">
                        <span v-if="scope.row.oldUserName">{{ scope.row.oldUserName }}</span>
                        <span v-else>--</span>
                    </template>
                </el-table-column>
                <el-table-column :show-overflow-tooltip="true" :label="$t('colUnBindRecord.newUser')">
                    <template slot-scope="scope">
                        <span v-if="scope.row.newUserName" :class="{'redirects':scope.row.newUserName}">{{ scope.row.newUserName }}</span>
                        <span v-else>--</span>
                    </template>
                </el-table-column>
                                <el-table-column :show-overflow-tooltip="true" :label="$t('colUnBindRecord.unCount')">
                    <template slot-scope="scope">
                        <span v-if="scope.row.unBindCount">{{ scope.row.unBindCount }}</span>
                        <span v-else>--</span>
                    </template>
                </el-table-column>
                <el-table-column :show-overflow-tooltip="true" :label="$t('colUnBindRecord.unStatus')">
                    <template slot-scope="scope">
                        <span v-if=" scope.row.unBindAlarmStatus == 0" class="color-normal">{{ $t('statistic.normal') }}</span>
                        <span v-else-if=" scope.row.unBindAlarmStatus == 1" class="color-warning">{{ $t('alarm.warning') }}</span>
                        <span v-else>--</span>
                    </template>
                </el-table-column>
                <el-table-column :show-overflow-tooltip="true"  :label="`PN${$t('colUnBindRecord.pnBarCode')}`">
                    <template slot-scope="scope">
                        <template v-if="isValidImgUrl(scope.row.pnBarCodePicture)">
                            <el-image
                                :src="scope.row.pnBarCodePicture"
                                :preview-src-list="[scope.row.pnBarCodePicture]"
                                style="width: 40px; height: 40px; cursor: pointer;margin-top: 4px;"
                                fit="cover"
                                @error="onImgError(scope.row, 'pnBarCodePicture')"
                            >
                                <div slot="error" style="width:40px;height:40px;background:#eee;display:flex;align-items:center;justify-content:center;">--</div>
                            </el-image>
                        </template>
                        <span v-else>--</span>
                    </template>
                </el-table-column>
                <el-table-column :show-overflow-tooltip="true" :label="$t('colUnBindRecord.devicePicture')">
                    <template slot-scope="scope">
                        <template v-if="isValidImgUrl(scope.row.devicePicture)">
                            <el-image
                                :src="scope.row.devicePicture"
                                :preview-src-list="[scope.row.devicePicture]"
                                style="width: 40px; height: 40px; cursor: pointer;margin-top: 4px;"
                                fit="cover"
                                @error="onImgError(scope.row, 'devicePicture')"
                            >
                                <div slot="error" style="width:40px;height:40px;background:#eee;display:flex;align-items:center;justify-content:center;">--</div>
                            </el-image>
                        </template>
                        <span v-else>--</span>
                    </template>
                </el-table-column>
                <el-table-column min-width="120px;" :show-overflow-tooltip="true" :label="$t('colUnBindRecord.ip')">
                    <template slot-scope="scope">
                        <span v-if="scope.row.ip">{{ scope.row.ip }}</span>
                        <span v-else>--</span>
                    </template>
                </el-table-column>
                <el-table-column min-width="120px;" :show-overflow-tooltip="true" :label="$t('colUnBindRecord.unTime')">
                    <template slot-scope="scope">
                        <span v-if="scope.row.createTime">{{ scope.row.createTime }}</span>
                        <span v-else>--</span>
                    </template>
                </el-table-column>
            </el-table>
            <div class="tablebottom">
                <!-- 批量占位 -->
                <span class="" style="margin-left:16px;"></span>
                <el-pagination class="pagination" background @size-change="getDeviceList(true)"
                    @current-change="() => getDeviceList()" :current-page.sync="pagination.currentPage"
                    :page-sizes="[10, 15, 20, 30, 50]" :page-size.sync="pagination.pagesize"
                    layout="slot, sizes, total, pager, prev, next, jumper" :total="pagination.total"
                    popper-class="select-page">
                    <span style="color:#ffffff;padding-left:15px;">{{ $t('device.pageSize') }} :</span>
                </el-pagination>
            </div>
        </div>
    </div>
</template>
<script>
import bindingDialog from "@/components/dialognew";
export default {
    components: {
        bindingDialog
    },
    data() {
        return {
            pn: '',
            emptyText: false,
            ubStatusList: {
              0: {
                label: this.$t("statistic.normal"),
                class: 'status-normal',
                name: 'normal',
              },
              1: {
                label: this.$t("alarm.warning"),
                class: 'status-warning',
                name: 'warning',
              }
            },
            unBindAlarmStatus: '',//解绑状态
            pagination: {
                currentPage: 1,
                total: 0,
                pagesize: 15
            }, // 分页数据
            loadingDevice: false,
            deviceList: [],
            imgErrorMap: {}, // 记录图片加载失败的行和字段
        };
    },
    computed: {
    },
    watch: {
    },
    created() {
        this.getDeviceList();
    },
    methods: {
        // el-table树形row-key生成函数，优先用_uid
        getRowKey(row) {
            return row._uid || row.id || row.pn;
        },
        // 设备列表数据
        getDeviceList(reset) {
            this.loadingDevice = true
            if (reset) this.pagination.currentPage = 1;
            let params = {
                page: this.pagination.currentPage,
                pageSize: this.pagination.pagesize,
                pn: this.pn,
                projectCode: 'DESS',
                unBindAlarmStatus: this.unBindAlarmStatus,
            }
            this.$request.getMicroserDess("/css/api/pub/rpc/collectorUnBindRecord/page", params).then(res => {
                this.loadingDevice = false
                if (res.code == 0 &&res.data&& Array.isArray(res.data.items)) {
                    // 为父级和子级生成唯一id
                    const page = this.pagination.currentPage;
                    const pageSize = this.pagination.pagesize;
                    this.deviceList = res.data.items.map((row, idx) => {
                        const parentId = (page - 1) * pageSize + idx + 1;
                        row._uid = parentId;
                        // 1. 合并details[0]的所有参数到父级row
                        if (Array.isArray(row.details) && row.details.length > 0) {
                            Object.assign(row, row.details[0]);
                        }
                        // 2. 给所有details的child加pn和unBindCount=1
                        if (Array.isArray(row.details)) {
                            row.details = row.details.map((child, cidx) => {
                                child._uid = parentId + '-' + (cidx + 1);
                                child.pn = row.pn;
                                child.unBindCount = 1;
                                return child;
                            });
                        }
                        return row;
                    });
                    this.pagination.total =  res.data.total;
                }else{
                    this.emptyText = true;
                    this.deviceList = [];
                    this.pagination.total = 0;
                }
            }).catch((err) => {
                this.loadingDevice = false
                this.emptyText = true;
                this.deviceList = [];
                this.pagination.total = 0;
            })
            // let params = {
            //     page: this.pagination.currentPage - 1,
            //     pagesize: this.pagination.pagesize,
            //     i18n: this.$lang.currentLang,
            //     pn: this.pn,
            // }
            // this.$request.get("collectorProtocol", params).then(res => {
            //     this.loadingDevice = false
            //     if (res.err == 0) {
            //         this.deviceList = []
            //         res.dat.pn = this.pn
            //         this.deviceList.push(res.dat)
            //         this.pagination.total = res.dat.total
            //     } else {
            //         this.emptyText = true;
            //         this.deviceList = [];
            //         this.pagination.total = 0;
            //     }
            // }).catch((err) => {
            //     this.loadingDevice = false
            //     this.emptyText = true;
            //     this.deviceList = [];
            //     this.pagination.total = 0;
            // })



        },
                // 校验图片url是否有效（简单判断http/https和图片后缀）
        isValidImgUrl(url) {
            return typeof url === 'string' && /^https?:\/\/.+\.(jpg|jpeg|png|gif|webp)$/i.test(url);
        },
        // 图片加载失败处理
        onImgError(row, field) {
            // this.$set(this.imgErrorMap, row._uid + '-' + field, true);
        },
    }
};
</script>
<style lang="less" scoped>
@import url("../../../../assets/css/mixin.less");

.protocolBinding {
    display: flex;
    flex: 1;
    flex-direction: column;
    margin: 20px;
    // background-color: rgb(34, 45, 53);
    overflow: auto;

    /deep/.el-select .el-tag {
        max-width: 150px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        position: relative;
        padding-right: 18px;
    }

    /deep/.el-select .el-tag__close.el-icon-close {
        position: absolute;
        top: 25%;
        right: 0;
    }

    .redirects {
        color: @primaryTextColor;
    }

    .operation {
        color: @primaryTextColor;
    }

    .btn {
        padding: 6px 12px;
        border-radius: 6px;
        font-size: 14px;
        cursor: pointer;
    }

    .btn-disable {
        color: rgba(242, 242, 242, 0.5);
        background: rgba(43, 56, 66, 1);
        cursor: not-allowed;
    }

    .btn-dark {
        background: @primaryTextColor;
        color: rgba(34, 45, 53, 1);
        border: none;
    }

    .btn-light {
        background: transparent;
        color: @primaryTextColor;
        border: 1px solid @primaryTextColor;
    }

    .ico-recharge {
        background: url(../../../../assets/img/general/Icon_Recharge.png);
    }

    .ico {
        display: inline-block;
        width: 20px;
        height: 20px;
        background-repeat: no-repeat;
        background-size: 100%;
        background-position: center;
        vertical-align: middle;
    }

    .section {
        display: flex;
        flex: 1;
        padding: 0px;
        flex-direction: column;
        border-radius: 0px;
        border: none;
        background: rgb(34, 45, 53);
        position: relative;
        overflow: hidden;

        /deep/.el-icon-loading {
            font-size: 28px;
        }

        .search {
            margin: 0px;
            display: flex;
            justify-content: space-between;
            align-items: center;
            background: rgb(34, 45, 53);

            .searchLeft {
                .button-upload {
                    display: flex;
                    //多语言状态下文字间隔优化
                    line-height: 16px;
                    justify-content: space-between;
                    align-items: center;
                    width: 114px;
                    height: 48px;
                    background: @primaryTextColor;
                    color: rgb(34, 45, 53);
                    font-size: 14px;
                    border-radius: 0px;
                    border: none;
                    cursor: pointer;

                }
            }

            .searchRight {
                display: flex;
                justify-content: flex-end;

                .adminSearch {
                    border-left: 1px solid #7B8395;
                    display: flex;
                    justify-content: flex-start;

                    .searchAll {
                        /deep/.el-input__inner {
                            width: 220px;
                            padding-left: 10px;
                        }
                    }

                    .search-device {
                        display: inline-block;
                        line-height: 48px;
                        padding: 0 15px;
                        width: 100%;
                        font-size: 14px;
                        background: #202D35;
                        color: #33FFB6;
                        cursor: pointer;

                        &:hover {
                            background: @primaryColorTransparency30;
                            color: rgb(255, 255, 255, 1);
                        }
                    }

                    .search-hide {
                        display: inline-block;
                        // position: absolute;
                        // right: -58px;
                        // line-height: 48px;
                        height: 100%;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        padding: 0 15px;
                        font-size: 14px;
                        background: #202D35;
                        color: #7B8395;
                        border-left: 1px solid #7B8395;
                        cursor: pointer;

                        &:hover {
                            background: @primaryColorTransparency30;
                            color: rgb(255, 255, 255, 1);
                        }
                    }
                }
            }

            .statusName {
                padding: 0 16px;
                color: #ADB9C0;
                font-size: 12px;
                line-height: 48px;
                font-weight: 700;
            }

            .statusList {
                cursor: pointer;
                padding: 0 16px;
                color: #70818C;
                font-size: 14px;
                height: 48px;
                line-height: 48px;
            }

            .active {
                color: #00FEBB;
                border-bottom: 2px solid #00FEBB;
            }

            .search-label {
                display: inline-block;
                color: #ffffff;
                font-weight: bold;
                line-height: 48px;
                font-size: 14px;
                padding-left: 16px;
            }

            /deep/.el-select {
                width: 100px;
                border-right: 1px solid #738089;
            }

            /deep/.el-select:hover {
                background: @primaryColorTransparency30;
            }

            /deep/.el-input {
                width: 100%;
                text-align: center;
            }

            /deep/.el-input__inner {
                background: transparent;
                border: none;
                height: 48px;
                line-height: 48px;
                color: #ffffff;
                padding: 0 16px;
            }

            /deep/.el-input__suffix {
                right: 0px;
            }

            .button {
                height: 48px;
                line-height: 48px;
                padding: 0 25px;
                margin-top: 0px;
                color: @primaryTextColor;
                background: transparent;
                border: none;
            }

            .batch-alert {
                height: 48px;
                line-height: 48px;
            }

            // 添加数采器
            .button-addscq {
                // width: 114px;
                height: 48px;
                background: @primaryTextColor;
                color: rgb(34, 45, 53);
                font-size: 14px;
                border-radius: 0px;
                border: none;
                cursor: pointer;

                span {
                    font-size: 14px;
                }

                i {
                    margin-left: 10px;
                }
            }
        }

        .tableloding {

            // 加载数据时遮罩
            /deep/.el-loading-mask {
                background-color: rgb(34, 45, 53, .5);
            }

            /deep/.el-loading-spinner i {
                color: @primaryTextColor;
            }
        }

        .tablemain {
            border: none;
            background-color: rgb(34, 45, 53);

            .operation i {
                color: @primaryTextColor;
            }

            .operation1 i {
                color: @primaryColorTransparency30;
            }
            /deep/.el-table__expand-icon i{
                    color: var(--primaryTextColor, #30D096);
                    font-size: 14px;
            }
            // /deep/.cell{
            //     text-align: center;
            //    padding: 5px 16px;
            //    display: flex;
            //    align-items: center;
            //    justify-content: center;
            // }

            // 表格右侧边线
            // /deep/.el-table--border::after, 
            // /deep/.el-table--group::after {
            //   width: 0px;
            // }
            /deep/.el-checkbox .el-checkbox__input .el-checkbox__inner {
                width: 16px;
                height: 16px;
                background: transparent;
                border: 1px solid rgb(180, 184, 193);
                border-radius: 0px;
            }

            /deep/.el-checkbox .el-checkbox__input .el-checkbox__inner::after {
                top: 2px;
                left: 5px;
            }

            /deep/.el-table__header th {
                height: 48px;
            }

            /deep/.el-table__header th.is-leaf {
                border-color: rgba(198, 209, 221, 0.5);
                // border-bottom: none;
            }

            /deep/.el-table__header th>.cell {
                font-weight: normal;
                font-size: 12px;
            }

            /deep/.el-table__body tr,
            /deep/.el-table__body td {
                height: 50px;
                background-color: rgb(34, 45, 53);
                color: #ffffff;
                border-color: rgba(198, 209, 221, 0.5);
            }

            /deep/.el-table__body td.el-table-column--selection {
                background-color: rgb(65, 80, 90);
                color: #ffffff;
            }

            /deep/.el-table__body .cell.el-tooltip {
                font-size: 14px;
            }

            /deep/.el-table__fixed-right::before,
            /deep/.el-table__fixed::before {
                display: none;
            }

            ::-webkit-scrollbar {
                width: 6px;
                height: 6px;
                background-color: #222d35;
            }

            // 关于复选框
            /deep/.el-checkbox .el-checkbox__input.is-checked .el-checkbox__inner {
                background: @primaryTextColor;
                border: 1px solid @primaryTextColor;
            }

            /deep/.el-checkbox .el-checkbox__input.is-indeterminate .el-checkbox__inner {
                background: @primaryTextColor;
                border: 1px solid @primaryTextColor;
            }

            // 关于头部右侧空白
            /deep/.el-table__fixed-right-patch {
                background-color: rgb(65, 80, 90);
                border-bottom: none;
            }

            /deep/th.gutter {
                background-color: rgb(65, 80, 90);
            }
        }

        .tablebottom {
            display: flex;
            justify-content: space-between;
            align-items: center;
            border-top: 1px solid rgba(198, 209, 221, 0.5);

            // 分页
            .pagination {
                line-height: 48px;
                height: 48px;
                padding: 0;
                margin: 0;
                display: flex;
                justify-content: flex-start;
                align-items: center;
                margin-right: 16px;

                /deep/.el-pager li {
                    vertical-align: middle;
                }

                /deep/.el-select .el-input {
                    width: 90px;
                    margin: 0px;
                }

                /deep/.el-input .el-input__inner {
                    background-color: #202D35;
                    color: #ffffff;
                }

                /deep/.el-input__suffix {
                    right: 10px;
                }

                /deep/.el-pagination__sizes {
                    margin: 0px;
                    height: 48px;
                    line-height: 48px;
                }

                /deep/.el-pagination__total {
                    color: #fff;
                    padding-left: 15px;
                    border-left: 1px solid #7B8395;
                    height: 48px;
                    line-height: 48px;
                }

                /deep/.el-pager li:not(.disabled).active {
                    // background: #15C491;
                    // color: #ffffff;
                    background-color: #2B3842;
                    color: #15C491;
                }

                // li:not(.disabled):not(.active):hover
                /deep/.el-pager li:not(.disabled):hover {
                    background-color: @primaryColorTransparency30;
                    color: rgba(255, 255, 255, 1);
                }

                /deep/.el-pager li {
                    background-color: #2B3842;
                    color: #7B8395;
                }

                // 页条数下拉
                /deep/.el-select .el-input .el-input__inner {
                    border: none;
                    height: 48px;
                    line-height: 48px;
                    border-radius: 0px;
                }

                /deep/.el-select .el-input .el-input__inner:hover {
                    background: @primaryColorTransparency30;
                }

                // 跳页
                /deep/.el-pagination__jump {
                    color: #ffffff;
                }

                /deep/.el-pagination__editor {
                    padding: 0px 6px;
                }

                /deep/.el-pagination__editor.el-input .el-input__inner {
                    border: 1px solid #7B8395;
                }
            }

            // 分页前后按钮
            /deep/.el-pagination.is-background .btn-next,
            /deep/.el-pagination.is-background .btn-prev {
                background-color: #2B3842;
                color: #7B8395;
            }

            /deep/.el-pagination.is-background .btn-next:hover,
            /deep/.el-pagination.is-background .btn-prev:hover {
                background-color: @primaryColorTransparency30;
                color: rgba(255, 255, 255, 1);
            }

            /deep/.el-pagination.is-background button[disabled],
            /deep/.el-pagination.is-background button[disabled]:hover {
                background-color: #2B3842;
                color: #7B8395;
            }
        }
    }

    ::-webkit-scrollbar {
        width: 0px;
        height: 0px;
        background-color: #222d35;
    }
}
</style>
<style lang="less">
// #下拉选框#
.select-search-recharge {
    background-color: rgb(34, 45, 53);
    box-shadow: 0px 8px 21px rgba(11, 12, 13, 0.3);
    border-radius: 4px;
    border: none;
    padding: 8px 0px;

    .el-select-dropdown__list {
        padding: 0px;
    }

    .el-select-dropdown__item {
        padding: 0px 16px;
        font-size: 14px;
        height: 32px;
        line-height: 32px;
        color: rgba(255, 255, 255, 1);
    }

    .el-select-dropdown__item.hover {
        display: flex;
        align-items: center;
        padding: 0px 16px;
        background-color: transparent;
        font-weight: normal;
    }

    .el-select-dropdown__item.selected {
        padding: 0px 16px;
        background-color: transparent;
        font-weight: normal;
        color: rgba(255, 255, 255, 1);
    }

    .el-select-dropdown__item:hover {
        padding: 0px 16px;
        background: @primaryColorTransparency30;
        color: rgba(255, 255, 255, 1);
    }

    .el-select-dropdown__item.selected .select-label {
        padding: 0px;
    }

    // 对号
    .el-select-dropdown__item.selected:before,
    .el-select-dropdown__item.selected .select-label:before,
    .el-select-dropdown__item.selected.choose-num:before {
        content: "";
        display: inline-block;
        height: 16px;
        width: 16px;
        background: url(../../../../assets/img/general/Icon_Duihao.png);
        background-repeat: no-repeat;
        background-size: 100%;
        background-position: center;
        position: absolute;
        top: 8px;
        right: 16px;
    }

    // 下拉框上传固件按钮
    .upFirewareBtn {
        background: rgba(34, 45, 53, 1);
        border: 1px solid rgba(226, 227, 227, 1);
        border-radius: 6px;
        padding: 6px 30px;
        color: rgba(226, 227, 227, 1);
        font-size: 14px;
        cursor: pointer;
    }
}

.select-search-project {
    .el-select-dropdown__list {
        padding: 0 16px;
    }

    .el-select-dropdown__item {
        height: 40px;
        line-height: 40px;
        box-shadow: 0px 0.5px rgba(198, 209, 221, 0.2);
    }
}

.selectClearNew {

    // 下拉选中清除按钮
    .el-icon-circle-close:before {
        content: "";
        display: inline-block;
        height: 16px;
        width: 16px;
        background: url(../../../../assets/img/general/Icon_SelectClear.png);
        background-repeat: no-repeat;
        background-size: 100%;
        background-position: center;
        // position: absolute;
        // top: 8px;
        // right: 16px;
    }
}

// #时间选择器 el-date-picker#
.select-date {

    // 下拉
    &.el-date-picker {
        background: rgba(34, 45, 53, 1);
        border: none;
        box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.12), 0px 0px 1px rgba(0, 0, 0, 0.48);
    }

    // 切换日 -----
    // 头部切换
    .el-date-picker__header {
        padding: 0px 50px;
    }

    .el-date-picker__header-label {
        color: rgba(238, 236, 241, 1);
    }

    // 前后切换
    .el-picker-panel__icon-btn {
        color: rgba(48, 208, 150);
        font-size: 14px;
        font-weight: bold;
    }

    // 一周
    .el-date-table th {
        color: rgba(238, 236, 241, 1);
        border: none;
    }

    // 日
    .el-date-table td div {
        padding: 0px;
    }

    .el-date-table td.today span {
        color: #00FEBB;
        font-weight: normal;
    }

    .el-date-table td.available {
        color: rgba(122, 117, 133, 1);
        font-size: 14px;
    }

    .el-date-table td.available:hover {
        color: #00FEBB;
    }

    .el-date-table td.current:not(.disabled) span {
        width: 30px;
        height: 30px;
        line-height: 26px;
        text-align: center;
        border-radius: 16px;
        border: 2px solid @primaryColorTransparency30;
        background: @primaryColorTransparency30;
        color: rgba(51, 255, 182, 1);
        margin-top: -3px;
    }

    .el-date-table td.next-month,
    .el-date-table td.prev-month {
        color: rgb(60, 56, 68);
        font-size: 16px;
    }

    // 切换月 -----
    .el-date-picker__header--bordered {
        border: none;
    }

    // 月
    .el-month-table td.today .cell {
        color: #00FEBB;
    }

    .el-month-table td.current:not(.disabled) .cell {
        border-radius: 6px;
        border: 2px solid @primaryColorTransparency30;
        background: @primaryColorTransparency30;
        color: rgba(51, 255, 182, 1);
        line-height: 32px;
    }

    .el-month-table td .cell {
        color: #7B8395;
    }

    .el-month-table td .cell:hover {
        color: #00FEBB;
    }

    // 切换年 -----
    // 年
    .el-year-table td.today .cell {
        color: #00FEBB;
    }

    .el-year-table td.current:not(.disabled) .cell {
        border-radius: 6px;
        border: 2px solid @primaryColorTransparency30;
        background: @primaryColorTransparency30;
        color: rgba(51, 255, 182, 1);
        line-height: 28px;
    }

    .el-year-table td .cell {
        color: #7B8395;
    }

    .el-year-table td .cell:hover {
        color: #00FEBB;
    }
}

.tablemain.el-table--border::after {
    display: none;
}

.protocolBinding {
    .scqsbAlert {

        .el-table--border::after,
        .el-table--group::after {
            display: block;
            background-color: #A3A9B5;
        }

        // 弹窗表格右侧边线
        .el-table--border {
            border-right: 1px solid #A3A9B5;
        }

        // 滚动条
        ::-webkit-scrollbar {
            width: 6px;
            height: 6px;
            background-color: transparent;
        }

        // 加载数据时遮罩
        .el-loading-mask {
            background-color: transparent;
        }

        .el-loading-spinner i {
            color: @primaryTextColor;
        }
    }

    .upload-contents {
        border-radius: 6px;
        border: 1px dashed rgba(255, 255, 255, 0.5);
        padding: 10px;
        display: flex;
        flex-direction: column;
        align-items: center;

        .upload-buttonEquipment {
            background: transparent;
            border: none;
            cursor: pointer;
            padding: 6px 16px 6px 10px;
            color: rgba(255, 255, 255, 0.5);
            font-size: 14px;

            i {
                color: rgb(56, 165, 118);
                font-size: 32px;
            }
        }
    }

    .upload-input {
        display: none;
    }

    .uploadTips {
        margin: 10px auto;
    }
}
</style>